import { useCallback, useState } from 'react';

/** 1-based pagination — DoseSpot detailed list endpoints start at page 1. */
export interface WorklistPaginationState {
  readonly pageNumber: number;
  readonly nextPage: () => void;
  readonly previousPage: () => void;
}

export function useWorklistPagination(initialPage: number = 1): WorklistPaginationState {
  const startingPage = Math.max(1, Math.floor(initialPage));
  const [pageNumber, setPageNumber] = useState<number>(startingPage);

  const nextPage = useCallback(() => {
    setPageNumber((current) => current + 1);
  }, []);

  const previousPage = useCallback(() => {
    setPageNumber((current) => Math.max(1, current - 1));
  }, []);

  return { pageNumber, nextPage, previousPage };
}
